module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#proofread",
      toString: function () {
        return this.url;
      }
    }